<template>
  <v-card
    min-width="410"
    max-width=510
    class="mx-auto"

  >      <v-row justify="space-between">
        <v-card-title class="pt-2 pr-2">

       <v-avatar tile size=46>
          <img
                :alt="account.BankCode"
                :src="bankLogos[account.BankCode]"
             />
      </v-avatar>

          <div class="text-body-1 pl-2 font-weight-bold">
            {{ Bank }}
          </div>
              </v-card-title>
            <v-btn
            dark
            icon
            class="pr-4"
            @click="openEditDialog"
          >
        <v-icon color="grey">mdi-pencil</v-icon>
          </v-btn>
          <v-dialog v-model="editDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Επεξεργασία Τραπεζικού Λογαριασμού</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="editAccountForm">
            <v-container>
              <v-row>
                <v-col cols="12" sm="8" md="6">
                  <v-text-field
                    label="Account Name"
                    v-model="editedAccount.Owner"
                    :rules="[rules.required]"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="8" md="8" xs="12">
                  <v-text-field
                    label="IBAN"
                    v-model="editedAccount.Iban"
                    :rules="[rules.required, rules.iban]"
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="editDialog = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveEditedAccount">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
       
       <!-- <v-card-title>
          <v-btn
            dark
            icon
            class="mr-2"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            dark
            icon
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-card-title> -->



    </v-row>
     <v-list v-if="account.JobDesc">
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-sitemap
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ account.JobDesc }}</v-list-item-title>
          <v-list-item-subtitle>Θέση</v-list-item-subtitle>
        </v-list-item-content>
        </v-list-item>
        </v-list>
     <v-divider inset></v-divider>
   <v-list two-line>
    <v-list-item v-if="account.Iban">
      <v-list-item-icon>
        <v-icon color="primary">
          mdi-bank
        </v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ account.IbanPretty }}</v-list-item-title>
        <v-list-item-subtitle>IBAN</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-icon @click="copyFunc(account.Iban, 'To IBAN')">
        <v-icon>mdi-content-copy</v-icon>
      </v-list-item-icon>
    </v-list-item>

    <v-list-item v-if="account.AccountNumber">
      <v-list-item-icon>
        <v-icon color="primary">
          mdi-counter
        </v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ account.AccountNumber }}</v-list-item-title>
        <v-list-item-subtitle>Αριθμός Λογαριασμού</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-icon @click="copyFunc(account.AccountNumber, 'Ο αριθμός λογαριασμού')">
        <v-icon>mdi-content-copy</v-icon>
      </v-list-item-icon>
    </v-list-item>

      <v-list-item v-if="account.Remarks">
      <v-list-item-icon>
          <v-icon color="primary">
            mdi-phone-classic
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ account.Telephone }}</v-list-item-title>
          <v-list-item-subtitle>Work</v-list-item-subtitle>
        </v-list-item-content>

      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item v-if="account.Owner">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-briefcase-account
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ account.Owner }}</v-list-item-title>
          <v-list-item-subtitle>Δικαιούχος</v-list-item-subtitle>
        </v-list-item-content>

      </v-list-item>

      <v-list-item v-if="account.Email">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-email
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ account.Email }}</v-list-item-title>
          <v-list-item-subtitle>Personal</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>


      <v-divider v-if="account.Address" inset></v-divider>

      <v-list-item v-if="account.Address">
        <v-list-item-icon>
          <v-icon color="indigo">
            mdi-map-marker
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ account.Address }}</v-list-item-title>
          <v-list-item-subtitle>Orlando, FL 79938</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>

</template>

<script>

import ab from "../assets/ab.png"
import nbg from "../assets/nbg.png"
import pir from "../assets/pir.png"
import eb from "../assets/eb.png"

export default {
  name: 'BankAccountDetails',
  props: {
    account: { required: true, type: Object },
    copyFunc: {required: true, type: Function },
  },

  components: {
  },
  computed: {
    name () {
        return this.account.Owner;
    },
    Bank () {
       return this.banks[this.account.BankCode];
    },
    lastName () {
        return this.account.Name.split(" ")[1]
    },
  },
  watch: {
   // async invoiceId () { await this.fetchInvoice(); },
  },
  data() {
    return {
      loading: true,
      editedAccount: {
        Owner: '',
        Iban: '',
      },
      editDialog: false,
      banks: {
        "@EB": "Eurobank",
        "@NBG": "Εθνική",
        "@AB": "Alpha Bank",
        "@PIR": "Τράπεζα Πειραιώς",
      },
      bankLogos: {
        "@PIR": pir,
        "@NBG": nbg,
        "@AB": ab,
        "@EB": eb,
      },
      supplier_id: this.$route.params.id,
      rules: {
          required: value => !!value || 'Required.',
           iban: value => {
             const pattern = /^[A-Z]{2}[0-9]{25}$/
            if (value) {
                return pattern.test(value) || 'Invalid IBAN'
            }
            return
          },
           email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (value) {
                return pattern.test(value) || 'Invalid e-mail.'
            }
            return
          },
        },
      };
    },
    methods: {
      openEditDialog() {
      this.editDialog = true;
      // Load the current account details into editedAccount
      this.editedAccount = {
        Owner: this.account.Owner,
        Iban: this.account.Iban,
      };
    },
    async saveEditedAccount() {
  if (this.$refs.editAccountForm.validate()) {
    try {
      const response = await this.$api.put(`/banking/supplier/bank-account/${this.account.id}`, this.editedAccount);
      if (response.status === 200) {
        this.$emit('account-updated', response.data);
        this.editDialog = false;
      } else {
        alert(response.data.detail);
      }
    } catch (error) {
      console.error('Error updating account:', error);
    } finally {
      this.loading = false;
    }
  }
}
  },
};

</script>
